module.exports = __webpack_public_path__ + "static/NikiPham-0dace970d0af9f49400642c2ec297d36.jpg";